module.exports = "//static.hsappstatic.net/website-grader-ui/static-1.7936/img/website-performance-rating.jpg"